module.exports = __webpack_public_path__ + "img/IMG-20191124-WA0025.b7bc2277.jpg";